import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoRuleResponse, TaoRuleArgs } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { useTaoRulesContext } from "@/contexts/tao-rule-context";
import { buildApiUrl } from "@/utils/api";

const getTaoRules = async (params: TaoRuleArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().post<TaoRuleResponse>(buildApiUrl("taoRules"), {
    filters: params.filters,
  },
  {
    params: {
      practiceId: params.practiceId,
      requestedUser: params.requestedUser
    }
  });
  return data;
};

export const useTaoRules = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;
  const { filters } = useTaoRulesContext();


  return useQuery<TaoRuleResponse, Error>({
    queryKey: ["tao-routing-rules", practiceId, requestedUser, filters],
    queryFn: () => getTaoRules({ practiceId, requestedUser, filters }),
  });
};
